import { render, staticRenderFns } from "./PayerIndexeForm.vue?vue&type=template&id=d0990174"
import script from "./PayerIndexeForm.vue?vue&type=script&lang=js"
export * from "./PayerIndexeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports